import { QueryServiceCategories, SchemaTypes } from '@allesauto/graphql';
import { useQuery } from '@apollo/client';

/**
 * Custom hook that provides services with categories.
 * Returns services with categories.
 */
export const useServiceCategories = () => {
  const { data, loading, error } = useQuery<
    Pick<SchemaTypes.Query, 'workshopServiceCategories'>
  >(QueryServiceCategories);

  return {
    serviceCategories: data?.workshopServiceCategories ?? null,
    isLoading: loading,
    error,
  };
};
